export enum ProviderReviewsWorkflow {
  PreModeration = 'pre-moderation',
  PostModeration = 'post-moderation',
}
